import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper'

const SimpleList = ({rows, getPrimaryFunc, getSecondaryFunc, maxHeight}) => {

    const items = [];
    rows.forEach(row => {
        const item = (<ListItemText primary={getPrimaryFunc(row)} secondary={getSecondaryFunc(row)}/>);
        items.push(<ListItem id={row.id}>{item}</ListItem>);
    });

    return (
        <Paper style={{maxHeight: maxHeight, overflow: 'auto'}}>
            <List>
                {items}
            </List>
        </Paper>
    );
}

export default SimpleList;